import styled from "styled-components";
import { COLORS, responsive, THEME } from "../../../../../styles/constants.style";

export const BulkSummaryDetailWrapper = styled.div`
  background: ${COLORS.cirrus_white};
  padding: 48px 0;
  margin: 32px 0;

  ${responsive.MOBILE`
    padding: 32px 0;
  `}

  .unprocessed-label {
    margin-top: 32px;
    text-align: center;
    color: ${COLORS.cirrus_black7};
    line-height: 16px;
    font-family: ${THEME.fontFamilies.secondary};
  }

  .footer-button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-top: 40px;
  }

  .done-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
  }

  .btn-tertiary svg {
    margin-right: 6px;
  }
`;
